import { IHeaderParams } from "ag-grid-community";
import React, { useState } from "react";

import { IgLink } from "@intelligems/ig-theme/IgLink";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import Stack from "@mui/material/Stack";
import { HeaderParams } from "@src/components/MainApp/SharedProductPicker/types";
import { useSelector } from "@src/store";
import {
  getProductPickerFilters,
  getProductPickerLoadedCount,
  getProductPickerProductCount,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const ProductListProductHeader = (
  props: IHeaderParams<ProductPickerSelectedProduct>
) => {
  const count = useSelector(getProductPickerProductCount);
  const loaded = useSelector(getProductPickerLoadedCount);
  const filters = useSelector(getProductPickerFilters);

  const [isExpanded, setExpanded] = useState<boolean>(false);

  const info =
    count !== undefined
      ? !filters.collection_id
        ? ` (${loaded} of ${count})`
        : ` (${loaded} loaded)`
      : "";
  const headerParams = props.column.getColDef().headerComponentParams as
    | HeaderParams
    | undefined;

  const handleExpandAll = () => {
    props.api.forEachNode((node) => {
      node.setExpanded(true);
    });
    setExpanded(true);
  };

  const handleCollapseAll = () => {
    props.api.forEachNode((node) => {
      node.setExpanded(false);
    });
    setExpanded(false);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={headerParams?.sx}
    >
      <IgTypography>
        Product
        {info}
      </IgTypography>
      {isExpanded ? (
        <IgLink
          fontWeight={"bold"}
          component="button"
          onClick={handleCollapseAll}
        >
          Collapse All
        </IgLink>
      ) : (
        <IgLink
          fontWeight={"bold"}
          component="button"
          onClick={handleExpandAll}
        >
          Expand All
        </IgLink>
      )}
    </Stack>
  );
};
